<p-tabs
  [value]="selectedTabIndex"
  (valueChange)="selectedTabIndex = +$event.toString()"
>
  <p-tablist>
    <p-tab [value]="0">Update Extraction</p-tab>
    <p-tab [value]="1">Discard</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="0">
      <app-update-extraction
        *ngIf="selectedTabIndex == 0"
      ></app-update-extraction>
    </p-tabpanel>
    <p-tabpanel [value]="1">
      <exception-app-discard
        *ngIf="selectedTabIndex == 1"
      ></exception-app-discard>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
